export default __webpack_public_path__ + "static/15-6a1a275ec374b266c6019b8dd162c69d.png";